// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__ZKXdf","col":"CardReaderDesc_col__3GKCp","label":"CardReaderDesc_label__2s19c"};